import * as yup from "yup";

const validationSchema = yup.object().shape({
  member: yup.string().required("This field is required"),
});

export default validationSchema;
